/** Catalog order matters: Xentry marks a kit followed by its component rows.
 * Never infer a kit from a shared callout, similar name, or repeated part ID.
 */
export interface CatalogKitPart {
  partId?: string | null;
  partNumber?: string | null;
  part_number?: string | null;
  extra_details?: Record<string, unknown> | null;
}
const yes = (value: unknown) => /^(yes|true|1)$/i.test(String(value ?? ''));
export const catalogPartIdentity = (part: CatalogKitPart): string =>
  String(part.partId || part.partNumber || part.part_number || '').trim();
export const isCatalogKit = (part: CatalogKitPart): boolean => yes(part.extra_details?.building_kit);

export function catalogKits<T extends CatalogKitPart>(parts: T[]): Array<{ kit: T; members: T[] }> {
  const groups: Array<{ kit: T; members: T[] }> = [];
  let current: { kit: T; members: T[] } | undefined;
  for (const part of parts) {
    if (isCatalogKit(part)) {
      current = { kit: part, members: [] };
      groups.push(current);
    } else if (yes(part.extra_details?.part_of_building_kit)) {
      if (current && catalogPartIdentity(part) !== catalogPartIdentity(current.kit)
        && !current.members.some(member => catalogPartIdentity(member) === catalogPartIdentity(part))) {
        current.members.push(part);
      }
    } else {
      current = undefined;
    }
  }
  return groups;
}
